var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-text"},[_c('h1',{staticClass:"display-text"},[_vm._v(_vm._s(_vm.name.first)+" "+_vm._s(_vm.name.last))]),_c('h2',{attrs:{"id":"typewriter"}},[_vm._v("Software Engineer")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }